export enum ApplicationType {
  Maintenance,
  Optimization,
  Installation
}
